import convertGermanFormatToNumber from '@/helpers/convertGermanFormatToNumber';

export const getNumberValue = (value: string | number) => {
  return typeof value === 'number' ? value : convertGermanFormatToNumber(value);
};
